//export const isAuthenticated = () => true;

export const isAuthenticated = () => {
  let token = localStorage.getItem("token");
  if (token) {
    //console.log("auth true");
    return true;
  } else {
    //console.log("auth false");
    return false;
  }
};
